var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-table',{ref:"table",attrs:{"table-columns":_vm.tableColumns,"url":_vm.url,"operate":[],"form-fields":{toTree: false, model: []},"permission":[],"searchs":_vm.searchs}})}
var staticRenderFns = []

export { render, staticRenderFns }